import React, { FC } from 'react';
import { AuthCallback } from '~/components';
import paths from '~/pages/paths';

const AgentAuthCallback: FC = () => (
  <AuthCallback flowKey="agent-signup" pathOnSuccess={paths.agent._} />
);

export default AgentAuthCallback;
